import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const DosPD = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Regulations</Paragraph>
        <Text className='BaseText2'>The development of any technology that is used for health issues must be <b>aligned with the requirements applicable to the General Health Law as well as the Regulations for the General Health Law in Matters for Health Research and the Regulations on Health Supplies.</b><br/>Additionally, depending on the type of biosensors, there are other regulatory elements that are applicable, such as official laws with regulatory standards for minimizing health risks, established in Mexico by the sanitary agency, COFEPRIS. In the following table, we include all the regulations that we need to take into account in order to guarantee that iMoAge is a safety tool for the consumer [3].</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-38.png'/>
          <p><b>Table 1.</b> Overview of main regulations in Mexico that apply to iMoAge. [4-9]</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default DosPD;
